import * as React from 'react';

function SvgRooms(props) {
  return (
    <svg width="3em" height="3em" viewBox="0 0 27.625 28.128" {...props}>
      <defs>
        <clipPath id="rooms_svg__a">
          <path data-name="Rectangle 4086" fill="#eea804" d="M0 0h27.625v28.128H0z" />
        </clipPath>
      </defs>
      <g data-name="Group 5572">
        <g data-name="Group 5571" clipPath="url(#rooms_svg__a)" fill="#eea804">
          <path
            data-name="Path 4103"
            d="M23.891 28.126v-1.494h.961a2.773 2.773 0 002.769-2.772v-9.889a2.77 2.77 0 00-2.768-2.773h-.118V2.774a2.777 2.777 0 00-2.773-2.776H5.227a2.765 2.765 0 00-1.974.821 2.726 2.726 0 00-.8 1.956c.022 4.27.022 7.489 0 8.458A2.77 2.77 0 000 13.971v9.889a2.775 2.775 0 002.769 2.772h.773v1.493H5.39v-1.493h16.653v1.493zM2.769 24.784a.921.921 0 01-.92-.924v-9.889a.921.921 0 01.92-.92h1.637a.921.921 0 01.92.92v10.813zm1.637-13.586H4.3c.018-1.1.018-3.907 0-8.439a.9.9 0 01.262-.643.949.949 0 01.665-.274h16.735a.928.928 0 01.924.928v8.428h-.118A2.774 2.774 0 0020 13.971v3.013H7.179v-3.013a2.773 2.773 0 00-2.773-2.773m2.772 7.63H20v2.192H7.179zm0 4.04H20v1.911H7.179zm14.668 1.911V13.971a.923.923 0 01.92-.92h2.085a.921.921 0 01.92.92v9.889a.921.921 0 01-.92.924z"
          />
          <path data-name="Rectangle 4085" d="M11.105 7.504h5.486v1.848h-5.486z" />
        </g>
      </g>
    </svg>
  );
}

export default SvgRooms;
